// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1_xiS","item":"PaymentsMobile_item__399LX","label":"PaymentsMobile_label__yRGXb","amount":"PaymentsMobile_amount__1Ajoi"};